var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A0A1A2;}\n\t.st1{fill:#0D2240;}\n\t.st2{fill:#276092;}\n\t.st3{fill:#77BC1F;}\n\t.st4{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M354.5,152L354.5,152l-1.6-4.8C330.5,82.5,269.4,39,200.9,39h0c-17.9,0-35.7,3-52.8,8.9 C64.3,77.1,19.7,169,48.8,252.8C71.3,317.5,132.4,361,200.9,361c17.9,0,35.7-3,52.8-8.9C335.9,323.5,380.3,234.5,354.5,152"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.9,355.3c-66,0-125-42-146.7-104.4C26.1,170.1,69.1,81.4,150,53.3c16.5-5.7,33.6-8.6,50.9-8.6 c66.1,0,125,41.9,146.7,104.4l0.7,2.1l0,0c26.6,80.3-16.3,167.7-96.5,195.5C235.3,352.4,218.2,355.3,200.9,355.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M217,130.3c-0.9-0.1-1.8-0.1-2.9-0.2c-5.7-0.4-14.7-1.1-25.5-4.8c-2.2,2.4-4,5-5.4,7.2 c2.8,2.9,8.1,8.4,10.7,11.4c4.5,2.7,9.1,5.7,13.6,8.9c7.2-8.1,13.6-14.7,19.9-21.3c-3.1-0.4-6.2-0.8-9.5-1.1L217,130.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M149.6,157c-12,16.8-20.5,38.8-21.3,65.1c12.8-14.1,23.3-27.1,30.5-34c5-4.8,10-8.1,14.6-10.3 c-4.8-11-11.1-20-19.6-24.2C152.2,154.7,150.8,155.9,149.6,157"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M183.6,116.1c7.1-2.9,14.8-5.9,22.3-8.3c9.4-3.4,17.8-5.3,24.3-6.3c-0.2,0-0.3-0.1-0.5-0.2 c-4.6-1.3-9.3-2.4-13.9-3c-12.7-1.9-25.4-1.3-37.5,1.4c-0.7,2.2-1.6,6.6-0.1,10.6C179.2,112.6,181,114.5,183.6,116.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M168.8,145c-2.8,1.3-5.9,2.9-8.9,4.6c8.4,5.5,14.6,14.8,19.3,25.7c6.7-2.3,11.3-2.4,11.3-2.4 c4.5-5.7,8.6-10.7,12.5-15.2c-4.5-3.1-9-6.1-13.5-8.7C184.6,147.2,172.9,145.5,168.8,145"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M194.2,120.2c8.4,2.5,15.3,3,20.3,3.3c1.2,0.1,2.2,0.2,3.1,0.2l0.7,0.1c3.2,0.3,7.8,0.8,13.1,1.7 c4-4.9,8.7-7.9,12-8.6c3.8,1.4,5.7,3.6,7.1,6.8c5.3,2.2,8.8,6.1,11.1,10.7c12.2,5.3,24.4,13.1,33.8,24.8 c-9.8-22.7-27.6-41.7-51.1-52.5l0,0.1c-0.3,0-21.9-0.5-48.7,12.5C195.1,119.6,194.6,119.9,194.2,120.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M303.4,191.5c-2.6-12.2-11.3-34.7-39-48.9c3.1,14-0.4,29.9-0.4,29.9s7.6,4.4,9.5,12.8c0,0,1,0.4,1.8,1.7 c2.1,2.6,4.8,8.6,0.5,20.4c0,0-2.6-5.5-8.1,0.4c-0.5,0.7-0.9,1.3-1.4,2c10.4,14.3,18.4,29.3,22.4,43.9 c4.6-7.6,8.4-15.9,11-24.9C303.3,216.3,304.4,203.7,303.4,191.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M121.5,229.4c-0.3-14.8,1.6-29,5.9-42.6c3.6-11.4,8.5-21,13.7-29.1c0.8-1.6,2.1-4,3.7-6.8 c-19.8-2.1-37.8,19-44.7,28.5c-4.6,22.2-1.5,44.5,7.5,63.9C112.4,238.8,117.1,234.1,121.5,229.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M251.9,254.9c-0.2,9.9,4.6,17.4,8.3,29.2c8.9-6.3,16.9-14,23.5-23c-3-14.7-10.7-30.3-21.4-45.3 C255.6,226.7,252.3,236.9,251.9,254.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M164.6,124.2c3.3-1.5,7.4-3.3,11.9-5.2c-2-1.8-3.5-4-4.4-6.4c-1.5-3.9-1.5-7.9-1-11.1 c-14.7,4.5-28.3,12.2-39.6,22.5c0.5,0,1.1,0,1.6,0C142.8,123.5,156.7,123.9,164.6,124.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.2,144.9c1.4-2.5,2.8-4.9,4.1-7.1c-5.5-3.6-8.9-6.2-18.3-7c-3.9-0.1-7.1,0-9.4,0.2 c-8.5,9.4-15.4,20.5-20.1,33C115,153,130.8,141.4,148.2,144.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M180.8,122.8l-7.1,10.3c0,0,5.4,3.7,9.8,8.8c-7.7-1.6-16.2-3-16.2-3l-13.5,7.3l6.3-10.5 c0,0-4.2-3.6-9.1-6.8c5.4,0.2,15.6,1,15.6,1L180.8,122.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M186.5,184.5c0,0-1.9,5.2-2.1,10c0,0-11.7,1.7-17.4,5.6C167.1,200,178.8,188.3,186.5,184.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M265.5,183.9c1.3-0.3,2.3-0.4,3-0.3c-0.2-0.6-0.6-1.5-1.3-2.4c-1-1.3-2.5-2.2-2.5-2.2 C265.6,180.5,265.6,182.6,265.5,183.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M254.9,189.3c1.5-1,2.9-1.9,4.1-2.6c-0.2-0.5-0.6-1.3-1.1-2.3c-1-1.8-3.6-3.4-3.6-3.4 C255.4,184.2,255.2,187.5,254.9,189.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.2,268.4c-10,4.1-33.5-1.5-33.5-1.5c23.8-1.4,47.1-18.4,47.1-18.4c0,0,0,0.1-0.1,0.1 c-7,10.7-16.6,16.9-16.6,16.9C127.2,266.8,128.3,267.7,129.2,268.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M248,126.3c0,0-5.9-4.6-12.5,2.5C242.6,115.8,246.7,123.3,248,126.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.1,189.1c0,0-0.6-0.4-0.7-0.5c-3.7-2-10.4,3.8-14.7,6.2c-4.3,2.4-10.7,7.5-13.7,0.5 c-3.1-7,4-18,6.5-24.9c5.4-15.3,5.6-24.2,4.5-29.1c5,5.7,6.6,16.5,6.6,16.5s1.9-20.4-8.1-25.7c0.2,0.7,0,3.3-0.2,5.3 c0,0,0,0,0,0c-4.6,0.8-14.9-0.3-18.2-2.1c-12.6,13.5-26.3,32.3-36.6,49.5c-4.5,9.1-8.9,19.8-10,28.5c0,0-1.4-3.9-1.8-9.2 c-5.7,2.2-25.1,11.7-29.3,41c0,0,12.3-12.7,26-17.7c0,0-8.6,22.6,7.9,62.7c0,0,6.7-24.6,20.6-30.8c8.5,42,33.3,42.7,40.5,71.3 c0,0,7.6-14.8-1.5-40c0,0,3.1,0.9,5.8,4c0,0-0.4-7.4-7.3-23.2c-4.5-8.5-5.9-20-5.9-20c-4,3.6-5.1,16-5.1,16 c-12.3-33.4,22.6-66.5,29-71.4c3.1-2.4,5-2.4,6.2-1.9C272.7,191.8,272.6,190.2,271.1,189.1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.2,130c-18.7-24.7-45.9-40.6-76.5-44.9c-5.3-0.7-10.7-1.1-16-1.1c-57.5,0-106.8,43-114.7,100.1 c-3.3,23.7,0.8,47.3,11.4,68.2c1.3-1.1,2.6-2.2,4-3.4c-9.7-19.7-13.4-41.8-10.3-64.1c7.5-54.6,54.7-95.7,109.7-95.7 c5.1,0,10.2,0.4,15.3,1.1c29.3,4,55.3,19.3,73.2,42.9c17.9,23.6,25.5,52.8,21.5,82.1c-4.5,32.3-22.8,59.9-48.5,77.1 c0.3,1.7,0.7,3.5,0.9,5.4c27.8-17.8,47.8-47.2,52.6-81.8C319.9,185.2,312,154.7,293.2,130"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M127.6,76.1c-5.6,0-10.1,4.5-10.1,10.1c0,5.6,4.5,10.1,10.1,10.1s10.1-4.5,10.1-10.1 C137.7,80.6,133.2,76.1,127.6,76.1 M127.6,91.8c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c3,0,5.5,2.5,5.5,5.5 C133.1,89.3,130.6,91.8,127.6,91.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.9,101.4l-2.4,1.3c-0.9,0.5-1.4,0.5-1.9,0.1c-0.6-0.5-0.5-1.3,0.3-2.1c0,0,0,0,0,0 c0.9-0.9,1.8-1.4,3-1.5l0.4,0l-0.3-4.5l-0.4,0c-2.2,0.1-4.3,1.1-6.2,3.2c-1.2,1.3-1.9,2.8-2.1,4.3c-0.2,1.8,0.5,3.4,1.9,4.6 c2.1,2,4.7,2.1,7.7,0.4l2.1-1.2c1.1-0.6,1.8-0.9,2.4-0.3c0.7,0.6,0.5,1.5-0.5,2.7c0,0,0,0,0,0c-1.4,1.5-2.9,1.6-4,1.6l-0.4,0 l-0.5,4.9l0.4,0c1.6,0.1,4.8-0.3,7.9-3.6c0,0,0.1-0.1,0.1-0.1c1.5-1.7,2.4-3.4,2.5-5.1c0.1-1.7-0.6-3.2-2.1-4.6 C110.7,99.5,108.3,99.5,104.9,101.4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.4,
    y: 201.3,
    transform: "matrix(0.9997 -2.375312e-02 2.375312e-02 0.9997 -4.815 1.6062)",
    className: "st4",
    width: 19.7,
    height: 4.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "93.1,135.1 100.6,123.9 96.9,121.5 91.9,128.9 89.2,127.1 93.5,120.7 89.8,118.3 85.5,124.7  82.8,122.9 87.8,115.4 84.2,113 76.8,124.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "157.7,81.9 152,67.7 157.1,65.6 155.4,61.6 141.2,67.4 142.8,71.4 147.9,69.3 153.6,83.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "76.8,146.4 62.9,152.8 62.7,153.4 81.1,160.9 82.7,156.9 73.2,153 87.1,146.6 87.4,145.9  69,138.4 67.3,142.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "67.8,175.9 55.7,185.2 55.6,186 75.2,189 75.9,184.7 65.7,183.1 77.8,173.7 77.9,173 58.3,169.9  57.6,174.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.3,
    y: 68.4,
    transform: "matrix(0.2842 -0.9588 0.9588 0.2842 104.1135 280.7726)",
    className: "st4",
    width: 19.7,
    height: 4.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "343.2,230 344.2,225.7 325,221.2 322.1,234 326.4,235 328.4,226.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M336.3,190.6c-5.6,0-10.1,4.5-10.1,10.1c0,5.6,4.5,10.1,10.1,10.1c5.6,0,10.1-4.5,10.1-10.1 C346.4,195.2,341.9,190.6,336.3,190.6 M336.3,206.3c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c3,0,5.5,2.5,5.5,5.5 C341.8,203.8,339.4,206.3,336.3,206.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "296.4,118.6 304.7,129.1 308.2,126.4 302.6,119.3 305.2,117.3 310,123.4 313.4,120.6 308.6,114.6  311.2,112.6 316.7,119.6 320.1,116.9 311.8,106.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "310,262.5 302.9,273.8 306.6,276.1 311.4,268.6 314.2,270.3 310,276.9 313.8,279.2 317.9,272.7  320.6,274.4 315.8,282 319.5,284.3 326.7,273  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "220.3,76.1 222.3,60.9 227.7,61.6 228.3,57.3 213.1,55.3 212.5,59.6 217.9,60.3 215.9,75.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "326.8,250.9 337.5,250.4 339.3,245.9 317.5,246.8 317.3,247.4 332.4,263.2 334.2,258.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "264,80.6 260.5,67.4 260.5,67.3 259.9,67 250.7,84.6 254.6,86.7 258.8,78.5 260.8,86.1  261.3,86.3 268.7,83.7 264.4,91.8 268.3,93.8 277.5,76.2 277,75.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "68.5,229 60.5,240.1 60.4,240.2 60.5,240.8 80,236.7 79.1,232.4 70.1,234.3 74.6,228 74.5,227.4  67.8,223.5 76.8,221.6 75.9,217.3 56.4,221.4 56.6,222  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "334.2,174.1 342.5,167.2 342.3,166.5 331.7,164 340.2,158.4 339.1,153.9 321.5,165.6 321.7,166.2  333.5,169 324.2,176.8 324.4,177.5 345.4,179.9 344.3,175.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M321.6,145.1c1.7,1.8,4.5,2,6.9,0.8c3.7-1.8,4.8-5.5,2.8-9.6l-3.3-6.6l-17.7,8.7l2,4l8.2-4l-5.6,9.3 l2.3,4.7C317.3,152.4,321.3,145.6,321.6,145.1 M322.4,140.6l-1.2-2.5l4.9-2.4l1.2,2.5c0.9,1.8,0.5,3.1-1.1,3.9 C324.6,142.8,323.3,142.4,322.4,140.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M294.5,101.6c1.1-0.3,2.1-0.9,2.9-1.9c1.2-1.4,1.7-3.2,1.4-4.9c-0.3-1.4-1-2.7-2.3-3.8l-2.5-2.1l-3.3-2.9 l-2.9,3.3l-2,2.3l-0.2,0.2l-2.7,3.1l-0.2,0.2l-2.2,2.5l-2.9,3.3l3.3,2.9l2.9,2.5c1.3,1.1,2.7,1.7,4.3,1.7 c1.8,0.1,3.6-0.7,4.8-2.1C294.1,104.7,294.6,103.2,294.5,101.6 M291.2,92.2l2.5,2.1c1,0.9,1.2,1.7,0.5,2.6 c-0.9,1-2,0.4-2.7-0.2l-2.3-2L291.2,92.2z M286.9,103l-2.9-2.5l2.3-2.7l2.7,2.4c1.1,1,1.4,2.1,0.7,2.9 C289,103.8,287.8,103.8,286.9,103"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M291.5,286.6c0.8-0.8,1.8-1.5,2.9-2.1c2.2-1,5.3-1.1,5.7-1.1l0,4.5c-0.9,0-2.8,0.2-3.7,0.6 c-1.4,0.7-2.4,1.7-2.6,2.7c-0.2,0.7,0.1,1.2,0.4,1.5c0.3,0.3,0.7,0.4,1.2,0.2c0.4-0.1,1.1-0.5,1.8-0.8c1.6-0.8,3.4-1.7,5-1.8 c1.7-0.2,3.2,0.3,4.4,1.5c1.4,1.3,1.9,3.2,1.8,4.5c-0.1,1.4-0.7,3.9-4,5.9c-1.9,1.2-4.6,1.5-4.9,1.6l-0.6-4.4 c0.8-0.1,2.2-0.5,3.1-0.9c2.3-1.1,2.4-3.7,0.5-3.6c-0.8,0-2.4,0.9-3.5,1.4c-0.9,0.5-1.7,0.8-2.4,1.1c-2.1,0.7-4.2,0.2-5.7-1.2 c-1.6-1.5-2.2-3.8-1.6-5.9C289.7,288.8,290.4,287.6,291.5,286.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "176.7,67.1 182.7,75.9 187.5,75.1 175.3,57 174.7,57.2 169.2,78.3 174,77.4  "
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMin);
export default __webpack_public_path__ + "static/media/MIN.81ee18050c32cede5bf040a9ec3d2fb5.svg";
export { ForwardRef as ReactComponent };